import { getContentTypeFromExtension } from "@perceptron/utils/mime";

import { MediaData } from "@demo/types/base";

/**
 * Helper to determine if an extension is a video type
 */
export function isVideoExtension(extension: string): boolean {
  try {
    const contentType = getContentTypeFromExtension(extension);
    return contentType.startsWith("video/");
  } catch {
    return false;
  }
}

/** What kind of media a file extension is, or `null` for anything else. */
export function mediaKindOfExtension(extension: string): "image" | "video" | "audio" | null {
  try {
    const contentType = getContentTypeFromExtension(extension);
    if (contentType.startsWith("video/")) return "video";
    if (contentType.startsWith("audio/")) return "audio";
    if (contentType.startsWith("image/")) return "image";
  } catch {
    // An unknown extension is none of them.
  }
  return null;
}

/**
 * Generates an image source URL from MediaData
 * Prefers URL if available, falls back to base64 data
 */
export const getImageSrc = (imageData?: MediaData): string => {
  if (!imageData) {
    return "";
  }

  // Prefer URL if available
  if (imageData.url) {
    return imageData.url;
  }

  // Fallback to base64 data
  if (!imageData.data || !getContentTypeFromExtension(imageData.extension)) {
    console.error("Invalid image data format:", imageData);
    return "";
  }
  return `data:${getContentTypeFromExtension(imageData.extension)};base64,${imageData.data}`;
};
